<template><expense-list scope="accessible" /></template>
<script>
import ExpenseList from './list'
export default { name: 'MyExpenseClaims', components: { ExpenseList } }
</script>
